import {
  useFeatureEntitlements,
  usePermissionEntitlements,
} from '@frontegg/react';
import { useGetCurrentPractitioner } from 'src/hooks/settings';

/** Phone triage module + permission to read calls (full Phone area). */
export function usePhoneTriageFullAccess(): boolean {
  const { isEntitled: hasPhone } = useFeatureEntitlements('phone-triage');
  const { isEntitled: hasCallRead } = usePermissionEntitlements('calls.read');
  return Boolean(hasPhone && hasCallRead);
}

/** Admin Call QA feature (may be granted without full phone triage). */
export function useCallQaNavAccess(): boolean {
  const { isEntitled: hasPhoneQa } = useFeatureEntitlements('phone-qa');
  const { isAdmin } = useGetCurrentPractitioner();
  return Boolean(hasPhoneQa && isAdmin);
}
